import { ChainId } from '@emberswap/emberswap-sdk2/dist/enums'
import React, { FC, ReactNode, useCallback, useMemo, useState } from 'react'
import { Signature } from 'viem'

// import { useNotifications } from '../../lib/state/storage'
import { Button } from '../Button'
import { Loader } from '../Loader'
import { TradeExecuteProvider } from '../TradeExecuteProvider'
import { useTrade } from '../TradeProvider'
import { SwapReviewModalBase } from './SwapReviewModalBase'

interface SwapReviewModalLegacy {
  chainId: ChainId
  children({ setOpen }: { setOpen(open: boolean): void }): ReactNode
  onSuccess(): void
  recipient?: string
}

export const SwapReviewModalLegacy: FC<SwapReviewModalLegacy> = ({ chainId, children, onSuccess, recipient }) => {
  const { trade } = useTrade()
  const [open, setOpen] = useState(false)
  const [signature, setSignature] = useState<Signature>()

  const [input0, input1] = useMemo(
    () => [trade?.inputAmount, trade?.outputAmount],
    [trade?.inputAmount, trade?.outputAmount]
  )

  const onSwapSuccess = useCallback(() => {
    setSignature(undefined)
    setOpen(false)

    onSuccess()
  }, [onSuccess])


  return (
    <>
      {children({ setOpen })}
      <SwapReviewModalBase
        recipient={recipient}
        chainId={chainId}
        input0={input0}
        input1={input1}
        open={open}
        setOpen={setOpen}
      >
        <TradeExecuteProvider
          /* trade={trade} mainCurrency={mainCurrency} otherCurrency={otherCurrency}*/ chainId={
            chainId
          }
          recipient={recipient}
          approved={true}
          signature={signature}
          onSuccess={onSwapSuccess}
        >
          {({ isWritePending, execute }) => {
            console.log('sendTransaction function to exec', {
              sendTrasaction: execute,
            })
            return (
              <Button
                size="md"
                testdata-id="swap-review-confirm-button"
                disabled={isWritePending}
                fullWidth
                onClick={() => execute?.()}
                variant="filled"
                color="red"
              >
                {isWritePending ? (
                  <>
                    Confirm Swap
                    <Loader.Dots />
                  </>
                ) : (
                  'Swap'
                )}
              </Button>
            )
          }}
        </TradeExecuteProvider>
      </SwapReviewModalBase>
    </>
  )
}
